var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcAvatar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_3006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.61 24.5196C29.0031 22.7786 27.0532 21.3892 24.8829 20.4389C22.7127 19.4886 20.3692 18.998 18 18.998C15.6308 18.998 13.2873 19.4886 11.1171 20.4389C8.94681 21.3892 6.99685 22.7786 5.39 24.5196C5.14192 24.7939 5.00314 25.1498 5 25.5196V31.5196C5.00526 31.9139 5.16561 32.2904 5.44635 32.5674C5.72709 32.8443 6.10562 32.9996 6.5 32.9996H29.5C29.8978 32.9996 30.2794 32.8416 30.5607 32.5603C30.842 32.279 31 31.8974 31 31.4996V25.4996C30.992 25.1367 30.8536 24.7888 30.61 24.5196Z",
    fill: "#5D5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17C21.866 17 25 13.866 25 10C25 6.13401 21.866 3 18 3C14.134 3 11 6.13401 11 10C11 13.866 14.134 17 18 17Z",
    fill: "#5D5CF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_3006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-avatar.2bc400b4.svg";
export { ForwardRef as ReactComponent };